export default {
    huawei: {
        contentList: [{
            title: "1、开启位置信息权限",
            text: "设置-应用-应用管理-定位有术-权限，将位置信息的权限设置为“始终允许”，以便查看定位和轨迹",
            eventType: 'location'
        }, {
            title: "2、开启应用自启动",
            text: "开启自启动权限，有效提高定位轨迹的完整度，在设置-应用-应用启动管理-定位有术，关闭自动管理，开启允许自启动",
            eventType: 'auto_run'
        }, {
            title: "3、加入清理白名单",
            text: "为保证运动轨迹的完整度，需加入清理白名单（锁定后台任务），在最近任务页面，找到定位有术，下拉锁定，应用名称右边显示锁定图标，即设置成功，如下图",
            eventType: 'clean_white_list'
        }, {
            title: "4、请勿开启省电模式",
            text: "在设置-电池，关闭省电模式。省电模式下，将限制应用后台活动，导致定位失败、轨迹异常等情况",
            eventType: 'power_mode',
            unShowSeting: true,//影藏按钮
        }, {
            title: "5、不允许电池优化",
            text: "在设置-应用-权限管理-特殊访问权限-电池优化，找到定位有术，选择“不优化”，如下图，有效提高应用的稳定性",
            eventType: 'battery_optimize'
        }]
    },
    xiaomi: {
        contentList: [{
            title: "1、开启位置信息权限",
            text: "在设置-应用设置-应用管理-定位有术-权限管理，将定位权限设置为“始终允许”，以便查看定位和轨迹",
            eventType: 'location'
        }, {
            title: "2、开启应用自启动",
            text: "开启自启动权限，有效提高定位轨迹的完整度，在设置-应用设置-应用管理-定位有术，点击打开自启动的开关，如下图",
            eventType: 'auto_run'
        }, {
            title: "3、加入清理白名单",
            text: "为保证运动轨迹的完整度，需加入清理白名单（锁定后台任务），在最近任务中，找到定位有术，长按应用界面，点击锁定图标，应用名称右边显示锁定图标，即设置成功",
            eventType: 'clean_white_list'
        }, {
            title: "4、请勿开启省电模式",
            text: "在设置-电池与性能，关闭省电模式。开启省电模式可能会影响数据上传，导致定位轨迹中断或异常等问题",
            eventType: 'power_mode',
            unShowSeting: true,//影藏按钮
        }, {
            title: "5、省电策略设置为无限制",
            text: "在设置-应用设置-应用管理-定位有术-省电策略，将省电策略设置为“无限制”，如下图",
            eventType: 'power_strategy'
        }, {
            title: "6、不允许电池优化",
            text: "在设置-隐私保护-管理-特殊应用权限-电池优化，找到定位有术，选择“不优化”，有效提高应用的稳定性",
            eventType: 'battery_optimize'
        }]
    },
    oppo: {
        contentList: [{
            title: "1、开启位置信息权限",
            text: "在设置-应用管理-应用列表-定位有术-应用权限，将位置信息的权限设置为“允许”，以便查看定位和轨迹",
            eventType: 'location'
        }, {
            title: "2、开启应用自启动",
            text: "开启自启动权限，有效提高定位轨迹的完整度，在设置-应用管理-自启动管理，找到定位有术，开启自启动",
            eventType: 'auto_run'
        }, {
            title: "3、加入清理白名单",
            text: "为保证运动轨迹的完整度，需加入清理白名单（锁定后台任务），在最近任务页面，找到定位有术，点击更多图标，点击锁定，应用名称右边显示锁定图标，即设置成功",
            eventType: 'clean_white_list'
        }, {
            title: "4、请勿开启省电模式",
            text: "在设置-电池，关闭省电模式。省电模式下，将限制应用后台活动，导致定位失败、轨迹异常等情况",
            eventType: 'power_mode',
            unShowSeting: true,//影藏按钮
        }, {
            title: "5、关闭应用速冻",
            text: "开启应用速冻，可能会影响应用运行，从而导致定位不准确等，故建议关闭应用速冻，在设置-电池-应用速冻，找到定位有术，关闭开关",
            eventType: 'frozen_app'
        }, {
            title: "6、允许应用通知",
            text: "在设置-应用管理-应用列表-定位有术-通知管理，开启允许通知，保证及时接收好友消息",
            eventType: 'notice'
        }]
    },
    vivo: {
        contentList: [{
            title: "1、开启位置信息权限",
            text: "设置-应用与权限-应用管理-定位有术-权限，将定位的权限设置为“始终允许”，以便查看定位和轨迹 ",
            eventType: 'location'
        }, {
            title: "2、开启应用自启动",
            text: "开启自启动权限，有效提高定位轨迹的完整度，在设置-应用与权限-权限管理-自启动-定位有术，关闭自动管理，开启允许自启动",
            eventType: 'auto_run'
        }, {
            title: "3、加入清理白名单",
            text: "为保证运动轨迹的完整度，需加入清理白名单（锁定后台任务），在最近任务页面，找到定位有术，下拉锁定，应用名称右边显示锁定图标，即设置成功",
            eventType: 'clean_white_list'
        }, {
            title: "4、电池设置为正常模式",
            text: "在设置-电池，选择正常模式。在省电模式下，将限制应用后台活动，可能导致定位失败、轨迹异常等情况",
            eventType: 'power_mode',
            unShowSeting: true,//影藏按钮
        }, {
            title: "5、不允许电池优化",
            text: "将定位有术的电池优化设置为“不优化”，如下图，有效提高应用的稳定性",
            eventType: 'battery_optimize'
        }, {
            title: "6、开启允许后台高耗电",
            text: "在设置-电池-后台高耗电，找到定位有术，开启开关，允许后台高耗电，若关闭则可能会限制应用在后台的正常运行，导致定位中断、定位轨迹不完整",
            eventType: 'backend_power'
        }]
    }
}